(function () {
  var COOKIE_NAME = 'bb_lang_shown';
  var COOKIE_DOMAIN = '.bottegabernacca.co';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? match[1] : null;
  }

  function setCookie(name, value) {
    document.cookie = name + '=' + value + '; path=/; domain=' + COOKIE_DOMAIN + '; SameSite=Lax';
  }

  function init() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    var overlay = document.getElementById('language-selector-overlay');
    if (!overlay) return;

    overlay.querySelectorAll('.lang-option').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault(); // suppress default <a> navigation; JS drives it below

        // getAttribute avoids TypeScript 'dataset does not exist on Element' noise
        // and works identically in all browsers.
        var dataUrl = link.getAttribute('data-url');
        if (!dataUrl) return; // safety: bail if attribute is missing

        // Build target URL: market base domain + current pathname + hash.
        // Query string excluded — Shopify tracking params (shpxid, etc.) are
        // store-specific and must not cross market boundaries.
        var base = dataUrl.replace(/\/$/, '');
        var path = window.location.pathname + window.location.hash;
        var url  = base + path;

        // Fade out before navigating so the page doesn't flash through the overlay.
        document.documentElement.style.backgroundColor = '#1d1d1b';
        document.body.style.transition = 'opacity 0.25s ease';
        document.body.style.opacity = '0';
        setTimeout(function () { window.location.href = url; }, 260);
      });
    });

    var trigger = document.getElementById('language-selector-trigger');
    if (trigger) {
      trigger.addEventListener('click', function () {
        show(overlay);
      });
    }

    // Fecha com ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
        close(overlay);
      }
    });

    // Fecha ao clicar no fundo escuro (fora do inner)
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close(overlay);
    });

    if (!getCookie(COOKIE_NAME)) {
      show(overlay);
    } else {
      // Garante que o overlay está fechado mesmo se o DOM foi preservado
      // pelo View Transitions do Horizon entre navegações
      forceClose(overlay);
      enterPage();
    }
  }

  function show(overlay) {
    var isFirstVisit = document.documentElement.classList.contains('bb-lang-first-visit');

    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setCookie(COOKIE_NAME, '1');

    if (isFirstVisit) {
      // Overlay e filhos já estão visíveis via CSS; apenas transfere o controle para JS
      document.documentElement.classList.remove('bb-lang-first-visit');
      overlay.classList.add('is-visible');
    } else {
      // Trigger manual (ícone de idioma): anima overlay e filhos normalmente
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('is-visible');
        });
      });
    }
  }

  // Fecha com transição suave (trigger manual / ESC / clique fora)
  function close(overlay) {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    overlay.addEventListener('transitionend', function () {
      overlay.classList.remove('is-active');
    }, { once: true });
  }

  // Fecha imediatamente, sem animação (view transition / retorno de sessão)
  function forceClose(overlay) {
    overlay.classList.remove('is-active', 'is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Animação de entrada da página (visitas de retorno, sem overlay)
  function enterPage() {
    // Remove the class that kept body hidden before first paint (set by inline
    // script in theme.liquid) and immediately start the entrance animation.
    // Both happen in the same JS tick so there is no visible flash between them.
    document.documentElement.classList.remove('bb-return-visit');
    document.body.classList.add('bb-page-entering');
    document.body.addEventListener('animationend', function () {
      document.body.classList.remove('bb-page-entering');
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
